module.exports = __webpack_public_path__ + "static/media/alastria-org.baa446e1.png";